<template>
  <div :class="effect==='light'?'date-choose light':'date-choose dark'">
    <el-row type="flex" justify="space-between" align="middle">
      <div class="date-choose-text">
        <span @click="sendParamsFn('currentDay')" :class="value==='currentDay'?'active':''">今天</span>
        <el-divider direction="vertical"></el-divider>
        <span @click="changeDate('day')" :class="value==='day'?'active':''">日区间</span>
        <el-divider direction="vertical"></el-divider>
        <span @click="changeDate('month')" :class="value==='month'?'active':''">月区间</span>
        <el-divider direction="vertical"></el-divider>
        <span @click="changeDate('year')" :class="value==='year'?'active':''">年区间</span>
        <el-divider direction="vertical" v-if="showIntervalDate"></el-divider>
      </div>
      <div>
        <CustomerSelect v-if="showCustomer" v-model="customerId" ></CustomerSelect>
      </div>
      <div v-if="noWrap" class="no-wrap">
        <!-- 年区间 -->
        <el-row type="flex" justify="space-between" v-if="value==='year'">
          <div>
            <el-date-picker  v-model="year1"  type="year"  placeholder="开始年份" size="mini" style="width: 140px;" @change="startYearChange" :picker-options="setYearMinDisabled"> </el-date-picker>
            <span class="font-12">至</span>
            <el-date-picker :disabled="!year1"  v-model="year2"  type="year"  placeholder="结束年份" size="mini" style="width: 140px;" :picker-options="setYearMaxDisabled"> </el-date-picker>
          </div>
          <el-button type="primary" size="mini" class="date-btn" @click="sendParamsFn">查询</el-button>
        </el-row>
        <!-- 月份区间 -->
        <el-row type="flex" justify="space-between" v-if="value==='month'">
          <el-date-picker size="mini" v-model="monthRange" type="monthrange" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="setMonthDisabled">
          </el-date-picker>
          <el-button type="primary" size="mini" class="date-btn" @click="sendParamsFn">查询</el-button>
        </el-row>
        <!-- 日区间 -->
        <el-row type="flex" justify="space-between" v-if="value==='day'">
          <el-date-picker style="width: 300px;" size="mini" v-model="dayRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="expireTimeOPtion">
          </el-date-picker>
          <el-button type="primary" size="mini" class="date-btn" @click="sendParamsFn">查询</el-button>
        </el-row>
      </div>
    </el-row>
    <!-- 年区间 -->
    <el-row class="margin-t-10" type="flex" justify="space-between" v-if="value==='year' && !noWrap">
      <div>
        <el-date-picker  v-model="year1"  type="year"  placeholder="开始年份" size="mini" style="width: 140px;" @change="startYearChange" :picker-options="setYearMinDisabled"> </el-date-picker>
        <span class="font-12">至</span>
        <el-date-picker :disabled="!year1"  v-model="year2"  type="year"  placeholder="结束年份" size="mini" style="width: 140px;" :picker-options="setYearMaxDisabled"> </el-date-picker>
      </div>
      <el-button type="primary" size="mini" class="date-btn" @click="sendParamsFn">查询</el-button>
    </el-row>
    <!-- 月份区间 -->
    <el-row class="margin-t-10" type="flex" justify="space-between" v-if="value==='month' && !noWrap">
      <el-date-picker size="mini" v-model="monthRange" type="monthrange" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="setMonthDisabled">
      </el-date-picker>
      <el-button type="primary" size="mini" class="date-btn" @click="sendParamsFn">查询</el-button>
    </el-row>
    <!-- 日区间 -->
    <el-row class="margin-t-10" type="flex" justify="space-between" v-if="value==='day' && !noWrap">
      <el-date-picker style="width: 300px;" size="mini" v-model="dayRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="expireTimeOPtion">
      </el-date-picker>
      <el-button type="primary" size="mini" class="date-btn" @click="sendParamsFn">查询</el-button>
    </el-row>
  </div>
</template>
<script>
import CustomerSelect from './customerSelect.vue'
import { getDay } from '@/utils/util'
export default {
  props: {
    // 是否显示客户下拉
    showCustomer: {
      type: Boolean,
      default: false
    },
    showIntervalDate: {
      type: Boolean,
      default: false
    },
    // dark黑色 light白色
    effect: {
      type: String,
      default: 'dark'
    },
    noWrap: { // 选择日期区间的组件 是否换行展示
      type: Boolean,
      default: true
    }
  },
  components: {
    CustomerSelect
  },
  watch: {
    'customerId': {
      handler(newValue) {
        console.log(newValue)
        // 只有当日期为今天时  选择用户直接查询；其他日期区间点击查询按钮查询
        if(this.value === 'currentDay') {
          let params = {
            statUnit: this.value
          };
          if(newValue) params.customerId = newValue;
          this.$emit('paramsInfo', params);
        }
      }
    }
  },
  data() {
    return {
      value: 'currentDay',
      value2: [],
      customerId: '',
      customerName: '',
      year1: '',
      year2: '',
      monthRange: [],
      dayRange: [],
      dayMin: '',
      monthMin: '',
      yearMin: '',
      setYearMinDisabled: {
        disabledDate: (time)=>{
          const curYear = new Date().getFullYear();
          const elYear = new Date(time).getFullYear();
         
          return elYear > curYear;
          
        }
      },
      setYearMaxDisabled: {
        disabledDate: (time)=>{
          const curYear = new Date().getFullYear();
          const elYear = new Date(time).getFullYear();

          const minYear = new Date(this.year1).getFullYear();
          const maxYear = new Date(this.yearMin).getFullYear() + 5;

          if (this.yearMin !== '') {
            return elYear > maxYear || elYear < minYear ||elYear > curYear;
          } else {
            return elYear > curYear;
          }
          
        }
      },
      expireTimeOPtion: {
        onPick: (time) => {
         this.$nextTick(() => {
          if(time.minDate) this.dayMin = new Date(time.minDate).getTime(); 
          
          if(time.maxDate){
            this.dayMin = ''
          }
        })
       },
        disabledDate: (time)=>{
          let times = 14 * 24 * 60 * 60 * 1000 ;// 最多只能选择15天
          if (this.dayMin !== '') {
            // 大于选中时间后15天 || 小于选中时间后15天 || 大于今天 的所有日期都禁用
            return time.getTime() > (this.dayMin + times) || time.getTime() < (this.dayMin - times) || time.getTime() > Date.now()
          }else{
            // 什么都没选，只禁用大于今天的所有日期
            return time.getTime() > Date.now()
          }
        }
      },
      setMonthDisabled: {
        onPick: (time) => {
         this.$nextTick(() => {
          if(time.minDate) this.monthMin = new Date(time.minDate).getTime();
         
          if(time.maxDate){
            this.monthMin = ''
          }
        })
       },
        disabledDate: (time) => {
          // 获取当前的月份信息
          const nowDate = this.getCurrentMonth(new Date());

          // 获取时间选择器的月份信息
          const elTimeData = this.getCurrentMonth(time);

          // 获取当前选择的月份信息
          const year = new Date(this.monthMin).getFullYear();
          let month = new Date(this.monthMin).getMonth() + 1;
          if (month >= 1 && month <= 9) {
            month = "0" + month;
          }
          // 区间值为当前选择的月份的前后12个月
          const minTimes = (year-1) + month;
          const maxTimes = (year+1) + month;

          if (this.monthMin !== '') {
            return elTimeData > maxTimes || elTimeData < minTimes || elTimeData > nowDate
          }else{
            return elTimeData > nowDate
          }
        },
      }
    }
  },
  methods: {
    changeDate(value) {
      this.value = value;
      let params = {
        statUnit: value
      };
      // 是否需要筛选用户
      if(this.showCustomer) params.customerId = this.customerId;
      const curDate = new Date();
      switch(value) {
        case 'day':
          // 默认当前时间往前15天
          this.dayRange = [curDate.getTime()-(14 * 24 * 60 * 60 * 1000), curDate ];
          params.startDate = getDay(new Date(this.dayRange[0]).getTime());
          params.endDate =  getDay(new Date(this.dayRange[1]).getTime());
          this.$emit('paramsInfo', params);
          break;
        case 'month':
          var date = new Date();
          var befdate = date.setMonth(date.getMonth() - 12);
          // 默认12个月
          this.monthRange = [new Date(befdate), curDate];
          params.startDate = this.getCurrentMonth(new Date(this.monthRange[0]).getTime());
          params.endDate =  this.getCurrentMonth(new Date(this.monthRange[1]).getTime());
          this.$emit('paramsInfo', params);
          break;
        case 'year':
          var date = new Date()
          var befdate = date.setMonth(date.getMonth() - 24);
          // 默认当前时间前两年
          this.year1 = new Date(befdate);
          this.year2 = curDate;
          params.startDate = new Date(this.year1).getFullYear();
          params.endDate =  new Date(this.year2).getFullYear();
          this.$emit('paramsInfo', params);
          break;
      }
    },
    startYearChange(year) {
      this.yearMin = year;
    },
    sendParamsFn(val) {
      if(typeof val==='string' && val) this.value = val;
      let params = {
        statUnit: this.value
      };
      // 是否需要筛选用户
      if(this.showCustomer) params.customerId = this.customerId;
      switch(this.value) {
        case 'currentDay':
          // let curDate = getDay(new Date().getTime());
          // params.startDate = curDate;
          // params.endDate = curDate;
          this.$emit('paramsInfo', params);
          break;
        case 'day':
          params.startDate = getDay(new Date(this.dayRange[0]).getTime());
          params.endDate =  getDay(new Date(this.dayRange[1]).getTime());
          this.$emit('paramsInfo', params);
          break;
        case 'month': 
          params.startDate = this.getCurrentMonth(new Date(this.monthRange[0]).getTime());
          params.endDate =  this.getCurrentMonth(new Date(this.monthRange[1]).getTime());
          this.$emit('paramsInfo', params);
          break;
        case 'year':
          params.startDate = new Date(this.year1).getFullYear();
          params.endDate =  new Date(this.year2).getFullYear();
          this.$emit('paramsInfo', params);
          break;
      }
    },
    // 获取年月  202302
    getCurrentMonth(times) {
      const date = new Date(times); // 获取当前的时间基本信息，值是这样的： Tue Jul 20 2021 14:59:43 GMT+0800 (中国标准时间)
      const year = date.getFullYear(); // 获取当前年份，值是这样的： 2021
      let month = date.getMonth() + 1; // 获取当前月份，值是这样的： 6  
      if (month >= 1 && month <= 9) {
        // 如果是1月到9月就要在前面补上一个0   比如：02、07    月份这样表示
        month = "0" + month;
      }
      const nowDate = year.toString() + month.toString(); 
      return nowDate
    }
  },
  created() {
    // this.getCurrentMonth(new Date());
  }
}
</script>
<style lang='scss' scoped>
// .el-input__inner {
//   background-color: transparent;
// }
.font-12 {
  font-size: 12px;
  display: inline-block;
  margin: 0 5px;
}
.margin-t-10 {
  margin-top: 10px;
}
.date-btn {
  margin-left: 10px;
}
.date-choose {
  >div {
    height: 100%;
  }
  &-text {
    height: 100%;
    display: flex;
    align-items: center;
    span{
      font-size: 10px;
      cursor: pointer;
    }
  } 
  // /deep/.el-date-editor .el-range-separator,
  // /deep/.el-date-editor .el-range__close-icon,
  // /deep/.el-date-editor .el-range__icon {
    // line-height: 13px!important;
  // }
}
.no-wrap {
  margin-left: 15px;
  // width: 430px;
}
.dark {
  color: #000!important;
}
.light {
  color: #fff!important;
}
.active {
  color: #FF6B00;
}
 </style>
